import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-64" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex--justify-space-between flex--wrap mb-24" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "No new notifications.", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NotificationsListComponent = _resolveComponent("NotificationsListComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.notifications)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: _normalizeClass(["notifications-total", { 'notifications-total--loading': $props.loading }])
            }, _toDisplayString($props.pendingCount) + " new notifications ", 3 /* TEXT, CLASS */),
            ($props.notifications.length && $props.pendingCount > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "p--small a a--fw-400",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.markAllAsRead && $options.markAllAsRead(...args)))
                }, " Mark all as read "))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_NotificationsListComponent, {
              notifications: $props.notifications,
              onMarkAsRead: $options.markAsRead
            }, null, 8 /* PROPS */, ["notifications", "onMarkAsRead"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
  ]))
}